// Stockage refusé (SecurityError à la simple lecture de window.localStorage) : cas d'une
// iframe sur un autre site (CMER, site d'une ligue...) quand le navigateur bloque les
// cookies tiers. Sans repli, l'application plante avant de s'afficher et l'iframe reste
// vide. Repli en mémoire : la page fonctionne, sans rien retenir d'une visite à l'autre
// (en intégration, la session vient de toute façon du site hôte, cf. embedHost.ts).
// Importé en premier par main.ts, avant tout code qui lit localStorage.
const storageAvailable = () => {
  try {
    const key = '__storage_test__';
    window.localStorage.setItem(key, key);
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};

if (!storageAvailable()) {
  const data = new Map<string, string>();
  const memoryStorage: Storage = {
    get length() { return data.size; },
    clear: () => data.clear(),
    getItem: (key) => data.get(key) ?? null,
    key: (index) => [...data.keys()][index] ?? null,
    removeItem: (key) => { data.delete(key); },
    setItem: (key, value) => { data.set(key, String(value)); },
  };
  Object.defineProperty(window, 'localStorage', { value: memoryStorage, configurable: true });
}
